// @flow

/**
 * Markdown Error Boundary
 * Catches and handles errors during markdown rendering, providing a fallback display
 */

import React from 'react';

class MarkdownErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(err) {
    if (typeof this.props.onError === 'function') {
      try {
        this.props.onError(err);
      } catch (e) {
        // Silently catch errors in error handler
      }
    }
  }

  render() {
    const { children, fallbackText } = this.props;
    if (this.state.hasError) {
      return (
        <pre style={{ margin: 0, whiteSpace: 'pre-wrap' }}>
          {fallbackText || ''}
        </pre>
      );
    }
    return children;
  }
}

export default MarkdownErrorBoundary;
